import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import ImgWithText from "../common/imgWithText"
import ResponsiveImage from "../common/responsiveImage"
import ResponsiveImageBadge from "../common/responsiveImageBadge"
import ResponsiveImageText from "../common/responsiveImageText"
import BabyBlanket from "../images/babyBlanket"
import BabyShrugLandscape from "../images/babyShrugLandscape"
import BabyShrugPortrait from "../images/babyShrugPortrait"
import styles from "./coachingProcessContent.module.css"
import config from "../../../data/SiteConfig"

export default function CoachingProcessContent() {
  const data = useStaticQuery(graphql`
    query {
      intro: allMarkdownRemark(
        filter: {
          fileAbsolutePath: { regex: "/(coachingProcess/1_intro.md)/" }
        }
      ) {
        edges {
          node {
            html
          }
        }
      }
      content: allMarkdownRemark(
        filter: {
          fileAbsolutePath: {
            regex: "/(coachingProcess/2_coaching-process.md)/"
          }
        }
      ) {
        edges {
          node {
            html
          }
        }
      }
      babyText: allMarkdownRemark(
        filter: {
          fileAbsolutePath: { regex: "/(coachingProcess/3_babyText.md)/" }
        }
      ) {
        edges {
          node {
            html
          }
        }
      }
    }
  `)

  return (
    <div>
      <ResponsiveImageText
        image={
          <ResponsiveImage
            portrait={<BabyShrugLandscape className={`stretchWide`} />}
            landscape={<BabyShrugPortrait />}
            breakpoint={config.layoutBreakpointDesktop}
          />
        }
      >
        <div
          dangerouslySetInnerHTML={{
            __html: data.intro.edges[0].node.html,
          }}
        />
      </ResponsiveImageText>
      <div
        dangerouslySetInnerHTML={{
          __html: data.content.edges[0].node.html,
        }}
      />
      <div className={styles.imageWrapper}>
        <ResponsiveImageBadge>
          <ImgWithText
            content={data.babyText.edges[0].node.html}
            contentClass={styles.bottomImageContent}
          >
            <BabyBlanket />
          </ImgWithText>
        </ResponsiveImageBadge>
      </div>
    </div>
  )
}
